import { memo, useState, useEffect } from 'react'
import cyclingTextData from '../../data/cyclingText.json'
import { parseHighlights } from './Subheading'

export const CyclingText = memo(function CyclingText({ screen, position = 'center' }) {
  const items = cyclingTextData[screen]
  const [index, setIndex] = useState(0)
  const [visible, setVisible] = useState(true)

  useEffect(() => {
    setIndex(0)
    setVisible(true)
  }, [screen])

  useEffect(() => {
    if (!items?.length) return
    let timeoutId = null
    const interval = setInterval(() => {
      setVisible(false)
      timeoutId = setTimeout(() => {
        setIndex(i => (i + 1) % items.length)
        setVisible(true)
      }, 400)
    }, 10000)
    return () => {
      clearInterval(interval)
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [items])

  if (!items?.length) return null

  const current = items[index]
  const isObject = typeof current === 'object' && current !== null

  return (
    <div className={`cycling-text-container cycling-text-container--${position}`}>
      <div className={`cycling-text${visible ? ' cycling-text--visible' : ''}`}>
        {isObject ? (
          <div className="cycling-text-inner">
            <img
              src={current.logo}
              alt=""
              className="cycling-text-logo"
            />
            <p>{parseHighlights(current.text)}</p>
            <div className="cycling-text-bottom-row">
              {current.attribution && (
                <p className="cycling-text-attribution">— {parseHighlights(current.attribution)}</p>
              )}
              <div className="cycling-text-dots">
                {items.map((_, i) => (
                  <span key={i} className={`cycling-text-dot${i === index ? ' cycling-text-dot--active' : ''}`} />
                ))}
              </div>
            </div>
          </div>
        ) : (
          parseHighlights(current)
        )}
      </div>
      {!isObject && (
        <div className="cycling-text-dots">
          {items.map((_, i) => (
            <span key={i} className={`cycling-text-dot${i === index ? ' cycling-text-dot--active' : ''}`} />
          ))}
        </div>
      )}
    </div>
  )
})
